export function formatRestaurantAddress(address) {
    return `${address.street}, ${[address.postCode, address.city].join(" ")}`;
}
